<template>
    <div class="projectBody">
        <div class="width_total_100 headerBg projectTopBg animateContent projectAnimate1">
            <div class="w_container">
                <div class="commonTop">
                    <OmpLink></OmpLink>
                </div>
                <div class="bannerPart">
                    <div class="line">
                        <img style="width:100px" src="https://escloud.digiwincloud.com/static/zh-TW/img/LINE.png" alt="line"/>
                        <p>掃描二維碼添加LINE</p>
                    </div>
                    <div style="padding-left: 120px;">
                        <div>賦予企業數據洞察力</div>
                        <p>引領商業變革風暴</p>
                    </div>
                    <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
                </div>
                <div class="instruction">
                    <div class="instruTitle">
                        <div>場景分析</div>
                        <p>Scene analysis</p>
                    </div>
                    <div class="sceneAnalysis">
                        <ul>
                            <li>
                                <div class="scenePer">
                                    <img src="@/assets/img/project_person1.png" />
                                    <i>中層</i>
                                    <div>工作彙報</div>
                                    <p>快速準確獲取數據報表，直接呈現問題根源，指導改進方向</p>
                                </div>
                            </li>
                            <li class="sceneSpecial">
                                <div class="scenePer">
                                    <img src="@/assets/img/project_person2.png" />
                                    <i>老闆</i>
                                    <div>企業監控</div>
                                    <p>一鍵查看關鍵營運數據，企業狀況一手在握，快速下達商業決策</p>
                                </div>
                            </li>
                            <li>
                                <div class="scenePer">
                                    <img src="@/assets/img/project_person3.png" />
                                    <i>職員</i>
                                    <div>問題回報</div>
                                    <p>全面收集、整理、分析各類數據，彙總報表。及時發現異常狀況，向上回報</p>
                                </div>
                            </li>
                            <div class="clear"></div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100 proBottomBg">
            <div class="w_container">
                <!--职能分析-->
                <div class="sceneFunAnalys" style="margin-top: 5px;">
                    <div class="instruTitle proMakeTitle">
                        <div>職能分析</div>
                        <p>Function analysis</p>
                    </div>
                    <div class="sceneCon">
                        <el-tabs type="border-card">
                            <el-tab-pane label="財務">
                                <div class="sceneTabCon">
                                    <div class="sceneTabCon_top clearfix">
                                        <div class="sceneTabConTop_left">
                                            <div>場景</div>
                                            <p>臨近月底，天天加班做報表，品類品號一個個對，幾十張圖表匯總分析，真頭大！</p>
                                        </div>
                                        <div class="sceneTabConTop_right">
                                            <div>痛點</div>
                                            <ul>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;做報告耗時長。</li>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;核對工作量大。</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="sceneTabCon_next clearfix">
                                        <img src="https://escloud.digiwincloud.com/static/zh-TW/img/scene_01.png" />
                                        <div class="sceneTabConNext_right">
                                            <div>解決方案</div>
                                            <ul>
                                                <li>多維度報表分析，按條件篩選查看</li>
                                                <li>多期間數據比較，年增率快速產生</li>
                                                <li>跨報表關聯功能，多報表隨意整合</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="業務">
                                <div class="sceneTabCon">
                                    <div class="sceneTabCon_top clearfix">
                                        <div class="sceneTabConTop_left">
                                            <div>場景</div>
                                            <p>這個季度A產品的銷售額離目標值還差幾十萬的缺口，看來今晚我得約大客戶李總吃個飯了....</p>
                                        </div>
                                        <div class="sceneTabConTop_right">
                                            <div>痛點</div>
                                            <ul>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;銷售目標是否達成難以定性。</li>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;難以多維度整理、查看報表。</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="sceneTabCon_next clearfix">
                                        <img src="https://escloud.digiwincloud.com/static/zh-TW/img/scene_02.png" />
                                        <div class="sceneTabConNext_right">
                                            <div>解決方案</div>
                                            <ul>
                                                <li>多資料來源上傳，歸納彙整數據不亂。</li>
                                                <li>直連E R P報表，按期篩選查看明細。</li>
                                                <li>設定當前目標值，制定對策衝業績。</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="生管">
                                <div class="sceneTabCon sceneSG">
                                    <div class="sceneTabCon_top clearfix">
                                        <div class="sceneTabConTop_left">
                                            <div>場景</div>
                                            <p>糟糕，今天客戶有急單，但資訊還沒給我統計出到底還缺哪些原料，哎，總是停工待料，怎麼辦....</p>
                                        </div>
                                        <div class="sceneTabConTop_right">
                                            <div>痛點</div>
                                            <ul>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;原材料經常出現短缺情況，導致工廠開工難。</li>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;原材料已領、未領情況不詳。</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="sceneTabCon_next clearfix">
                                        <img src="https://escloud.digiwincloud.com/static/zh-TW/img/scene_03.png" />
                                        <div class="sceneTabConNext_right">
                                            <div>解決方案</div>
                                            <ul>
                                                <li>人人都能做好圖表，簡單拖曳即可產出。</li>
                                                <li>報表自動上傳更新，原料狀況全程控管。</li>
                                                <li>隨時隨地查閱數據，工廠開工準時准點。</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="採購">
                                <div class="sceneTabCon">
                                    <div class="sceneTabCon_top clearfix">
                                        <div class="sceneTabConTop_left">
                                            <div>場景</div>
                                            <p>生產計畫一排程，就要給幾十個供應商打電話，真不知該從哪家先著手！</p>
                                        </div>
                                        <div class="sceneTabConTop_right">
                                            <div>痛點</div>
                                            <ul>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;採購貨品需經常對賬，費時費力。</li>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;難以知曉採購貨品是否已入庫。</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="sceneTabCon_next clearfix">
                                        <img src="https://escloud.digiwincloud.com/static/zh-TW/img/scene_04.png" />
                                        <div class="sceneTabConNext_right">
                                            <div>解決方案</div>
                                            <ul>
                                                <li>直連ERP報表，貨品明細好查詢。</li>
                                                <li>適時預警常提醒，貨品採購不遺忘。</li>
                                                <li>已購未進催廠商，免去對帳搶時效。</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="資訊">
                                <div class="sceneTabCon">
                                    <div class="sceneTabCon_top clearfix">
                                        <div class="sceneTabConTop_left">
                                            <div>場景</div>
                                            <p>每天都要花費大量時間幫不同的單位做報表，難道資訊職能就沒有更大的價值了嗎？</p>
                                        </div>
                                        <div class="sceneTabConTop_right">
                                            <div>痛點</div>
                                            <ul>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;耗費大量時間幫其他單位重複做圖表。</li>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;需要手動更新系統資料，做無價值勞動。</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="sceneTabCon_next clearfix">
                                        <img src="https://escloud.digiwincloud.com/static/zh-TW/img/scene_05.png" />
                                        <div class="sceneTabConNext_right">
                                            <div>解決方案</div>
                                            <ul>
                                                <li>設置圖表可保存，下次還能接著用。</li>
                                                <li>系統內置範本庫，資訊省事不加班。</li>
                                                <li>自動更新報表數，資料維護不斷鏈。</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
                <!--场景视频-->
                <div class="sceneVideo">
                    <div class="instruTitle proMakeTitle">
                        <div>場景視頻</div>
                        <p>Scene Video</p>
                    </div>
                    <div class="sceneVideoCon">
                       <ul>
                           <li v-for="(item, index) in videoArr">
                               <img :src="'https://escloud.digiwincloud.com/static/zh-TW/img/'+ item.id +'.png'" alt="" class="imgWidth">
                                <p class="sceneVideoTi">&nbsp;&nbsp;&nbsp;{{item.title}}
                                    <a class="playBtn" @click="toPlaying(item.id, item.title)"></a>
                                </p>
                           </li>
                       </ul>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        </div>
        <Control></Control>
        <FreeTry :visible.sync="freeTryVisible"></FreeTry>
        <!-- 模态框（Modal） -->
        <div class="modal fade" :id="'myModal'" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div style="width:70%; margin:0 auto;">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal">×</button>
                            <h4 class="modal-title" id="myModalLabel" style="font-weight:bold;">{{popVideoTitle}}</h4>
                        </div>
                        <video :src="'https://escloud.digiwincloud.com/static/zh-TW/video/'+ popVideoId +'.mp4'" controls="controls" preload="auto" :poster="'https://escloud.digiwincloud.com/static/zh-TW/img/'+ popVideoId +'.png'" id="popVideo" autoplay="autoplay" width="100%"></video>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import "@/assets/css/w-style.css"

    import OmpLink from "@/components/common/OmpLink.vue"
    import Control from "@/components/common/Control.vue"
    import Footer from "@/components/common/Footer.vue"
    import FreeTryButton from "@/components/common/FreeTryButton.vue"
    import FreeTry from "@/components/common/FreeTry.vue"

  export default {
    components: {
        OmpLink,
        Control,
        Footer,
        FreeTryButton,
        FreeTry
    },
    name: 'Scene',
    data() {
      return {
        freeTryVisible: false,
        videoArr: [
            {id:'sceneVideo_01', title:'財務篇'},//sceneVideo_1
            {id:'sceneVideo_02', title:'業務篇'},//sceneVideo_2
            {id:'sceneVideo_03', title:'用戶證言'}//sceneVideo_3
        ],
        
        popVideoId:'',
        popVideoTitle:'',
      }
    },
    created () {
        this.$http.post('/backend/web/record', {
            pageName: 'Scene',
            contentName : ''
        }, {headers: { "Content-Type": "application/json" }})
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    mounted() {
        this.projectTopAnimate(); // 顶部动画
         $('#myModal').on('hide.bs.modal',//模态框关闭触发事件
            function() {
                document.getElementById('popVideo').currentTime=0
                document.getElementById('popVideo').pause();
            })
    },
    methods: {
        projectTopAnimate() {
            var projectAnimate_show1=1;
            $(".projectBody").children(".animateContent").each(function() {
            if($(this).hasClass("projectAnimate1") &&  parseInt(projectAnimate_show1)){
                projectAnimate_show1 = 0;
                $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
                $(this).find(".sceneAnalysis li:nth-child(1)").delay(800).addClass('animated bounceInLeft');
                $(this).find(".sceneAnalysis li:nth-child(2)").delay(800).addClass('animated bounceInDown');
                $(this).find(".sceneAnalysis li:nth-child(3)").delay(800).addClass('animated bounceInRight');
            }
	     });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        },
         // @click 视频播放
        toPlaying(videoId,videoTitle){
            document.getElementById('popVideo').currentTime=0
            // document.getElementById('popVideo').play();
            this.popVideoId = videoId
            this.popVideoTitle = videoTitle
            $("#myModal").modal({});
        }
    }
  }
</script>
<style scoped>
.sceneVideoCon ul{
    display:flex;
    justify-content: space-between;
}
.sceneVideoCon ul li{
    width: calc(33% - 10px);
}
.sceneVideoCon ul li p{
    position: relative;
    background: #E6F7FF;
    height: 30px;
    line-height: 30px;
    text-align: left;
}
.sceneVideoCon ul li img{
    width: 100%;
}
.playBtn{
    position: absolute;
    top: 6px;
    right: 10px;
    width:0;
    height:0;
    border-top:8px solid transparent;
    border-bottom:8px solid transparent;
    border-left:12px solid #005D8C;
    cursor: pointer;
}
.playBtn:hover{
    opacity: 0.6;
}
.modal-dialog{
    width: 100%;
}
#myModal::-webkit-scrollbar{
    display:none;
}
</style>


// WEBPACK FOOTER //
// src/components/Scene.vue